import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage';

@Injectable()
export class StorageService {
  constructor(public storage: Storage,
   public platform: Platform) { }

  public set(settingName: string, value: any): void {
    this.storage.set(settingName, value);
  }

  public async get(settingName: string): Promise<any> {
   return await this.storage.get(settingName);
  }

  public remove(settingName: string): void {
    this.storage.remove(settingName);
  }

  public setSessionStorage(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  public getSessionStorage(key: string): string {
    return sessionStorage.getItem(key);
  }

  public removeSessionStorage(key: string): void {
    sessionStorage.removeItem(key);
  }
}
